import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ErrorType} from '@shared/models/ErrorTypes';
import {GlobalMessageType} from '@spartacus/core';
import {of} from 'rxjs';
import {catchError, concatMap, map} from 'rxjs/operators';
import {ShippingBacklogCancellationConnector} from '../../occ/connectors/shipping-backlog-cancellation.connector';
import {ShippingBacklogCancellationActions} from '../actions';
import {EfaGlobalMessageService} from '@shared/services/efa-global-message.service';

@Injectable()
export class ShippingBacklogCancellationEffect {
  sendShippingBacklogCancellation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ShippingBacklogCancellationActions.sendShippingBacklogCancellation),
      concatMap((action) =>
        this.connector.sendBacklogCancellationRequest(action.request).pipe(
          map(() => {
            return ShippingBacklogCancellationActions.sendShippingBacklogCancellationSuccess();
          }),
          catchError((error: ErrorType) => {
            this.globalMessageService.add(
              {
                key: 'shippingBacklog.globalMessage.cancellingShippingBacklogItemsFailure',
              },
              GlobalMessageType.MSG_TYPE_ERROR
            );
            return of(ShippingBacklogCancellationActions.sendShippingBacklogCancellationFailure({ errorResponse: error }));
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private connector: ShippingBacklogCancellationConnector,
    private globalMessageService: EfaGlobalMessageService
  ) {
  }
}
